import React from 'react';

/**
 * App-owned add-from-photos glyph. The picture frame with sun and mountains
 * provides the object, and the separate plus makes the action legible
 * without relying on color.
 */
const PhotoPlusIcon = ({ className = '' }) => (
  <svg
    data-icon="photo-plus"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <rect
      data-part="object"
      x="3"
      y="5.5"
      width="11.5"
      height="12"
      rx="2.2"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinejoin="round"
    />
    <circle cx="7" cy="9.3" r="1.3" fill="currentColor" opacity="0.38" />
    <path
      d="M4.5 15.6 7.7 12c.4-.44 1.1-.44 1.5 0l1.9 2.1 1.3-1.4c.4-.44 1.1-.44 1.5 0l.6.68v1.42h-10v-2.2Z"
      fill="currentColor"
      opacity="0.38"
    />
    <path
      data-part="landscape"
      d="M4.5 15.6 7.7 12c.4-.44 1.1-.44 1.5 0l1.9 2.1 1.3-1.4c.4-.44 1.1-.44 1.5 0l.6.68"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      data-part="plus"
      d="M18.5 5v7M15 8.5h7"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
  </svg>
);

export default PhotoPlusIcon;
